import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SandboxService } from 'src/app/core/services/data/sandbox.service';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-view-invoice',
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: './view-invoice.component.html',
  styleUrl: './view-invoice.component.scss',
})
export class ViewInvoiceComponent implements OnInit {
  invoiceNumber: string = '';
  lotNumber: string = '';
  pdfPreviewUrl: SafeResourceUrl | undefined;
  currentEntityId: string = '';
  isInvoiceFinalized: boolean = false;
  isFinalzing: boolean = false;
  pdfBlob: Blob | undefined;
  private previewObjectUrl: string | undefined;

  _route = inject(ActivatedRoute);
  _sandboxService = inject(SandboxService);
  _destroyRefService = inject(DestroyRef);
  _sanitizer = inject(DomSanitizer);
  _appGeneralState = inject(AppGeneralStateService);
  _dataService = inject(DataService);

  ngOnInit(): void {
    this.invoiceNumber = this._route.snapshot.params['invoicenumber'];
    this.currentEntityId = this._route.snapshot.params['entityId'];
    this.lotNumber = this._route.snapshot.params['lotNumber'];
    this.onDisplayPrelimInvoice(this.invoiceNumber);
  }

  onDisplayPrelimInvoice(invoiceNumber: string) {
    const setPreview = (response: any) => {
      this.pdfBlob = new Blob([response.body!], { type: 'application/pdf' });

      if (this.previewObjectUrl) {
        URL.revokeObjectURL(this.previewObjectUrl);
      }

      this.previewObjectUrl = URL.createObjectURL(this.pdfBlob);
      this.pdfPreviewUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
    };

    if (invoiceNumber.startsWith('GB')) {
      this._dataService.GetGbInvoicePdf(invoiceNumber, this.lotNumber).subscribe(setPreview);
      return;
    }

    this._dataService.GetMiInvoicePdf(invoiceNumber, this.lotNumber, this.currentEntityId).subscribe(setPreview);
  }

  downloadInvoicePdf(): void {
    if (!this.pdfBlob) {
      return;
    }

    const objectUrl = URL.createObjectURL(this.pdfBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = objectUrl;
    downloadLink.download = `${this.invoiceNumber}.pdf`;
    downloadLink.click();
    URL.revokeObjectURL(objectUrl);
  }

  onFinalizeInvoice() {
    // Placeholder for finalize invoice logic
    this.finalizeInvoiceHttp(this.invoiceNumber, this.lotNumber);
  }

  // getPdfBytes(invoiceNumber: string, lotNumber: string) {
  // }

  // getPdfBytes_ex(invoiceNumber: string, lotNumber: string) {
  //   this._sandboxService
  //     .getPdfTestMiInvoice(invoiceNumber, lotNumber)
  //     .pipe(takeUntilDestroyed(this._destroyRefService))
  //     .subscribe({
  //       next: (res) => {
  //         let blob: Blob = res.body as Blob;
  //         let url = window.URL.createObjectURL(blob);
  //         window.open(url, '_blank');
  //       },
  //       error: (err: any) => {
  //         console.error('error on fetch');
  //       },
  //       complete: () => {},
  //     });
  // }

  finalizeInvoiceHttp(invoiceNumber: string, lotNumber: string): void {
    this.isFinalzing = true;
    this._dataService
      .mi_FinalizePrelimInvoice(invoiceNumber, lotNumber)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {},
        error: (err: any) => {
          this.isFinalzing = false;
          console.error('error on finalize');
        },
        complete: () => {
          this.isFinalzing = false;
          this.isInvoiceFinalized = true;
        },
      });
  }

  handlePdfDownload(blob: Blob) {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = 'https://spacedownloadprod.blob.core.windows.net/downloadassets/MI01004052300006.pdf'; // Desired filename
    a.click();
    URL.revokeObjectURL(objectUrl); // Release the Blob URL
  }

  onSendInvoice(): void {
    this._dataService
      .sendInvoiceNotificationEmail(this.invoiceNumber)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {},
        error: (err: any) => {
          this.isFinalzing = false;
          console.error('error on sending invoice notification email');
        },
        complete: () => {
          this.isFinalzing = false;
          this.isInvoiceFinalized = true;
        },
      });
  }
}
